import React, { memo } from 'react';
import CN from 'classnames';
import { IMG_ROOT } from '../../const/paths';
import './ShipIcon.css';
import styled from 'styled-components';

const ShipIcon = ({
  icon,
  name,
  dim,
  borderColor,
  onClick,
  retrofitable,
  noBorder,
}) => (
  <div
    className={CN('ShipIcon', { 'ShipIcon--dim': dim, retrofit: retrofitable })}
    onClick={onClick}
    style={
      retrofitable
        ? {
            boxShadow: `0 0 11px 2px ${borderColor}`,
            color: borderColor,
            background: borderColor,
          }
        : { color: borderColor, background: borderColor }
    }
  >
    {retrofitable ? (
      <RetrofitIconWrap title="Retrofittable">
        <StyledRetrofitIcon />
      </RetrofitIconWrap>
    ) : null}
    <img
      src={IMG_ROOT + icon}
      alt={name}
      style={noBorder ? { border: 'none' } : { borderColor }}
    />
  </div>
);

export default memo(ShipIcon);

function RetrofitIcon({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512.2 512.2"
      width="24"
      height="24"
      className={className}
    >
      <path d="M477 217L263 3a11 11 0 00-15 0L35 217a11 11 0 008 18h117v267c0 5 5 10 11 10h171c6 0 10-5 10-10V235h117a11 11 0 008-18z" />
    </svg>
  );
}

const StyledRetrofitIcon = styled(RetrofitIcon)`
  fill: #fff;
  background: currentColor;
  border-radius: 50%;
  padding: 4px;
  box-shadow: 0px 0px 3px 0px rgb(0 0 0 / 28%);
`;

const RetrofitIconWrap = styled.div`
  position: absolute;
  z-index: 3;
  bottom: 4px;
  right: 4px;
`;
